module.exports = __webpack_public_path__ + "img/icon-settings-blue.8e5e95e2.svg";